import Lenis from "lenis";

// Singleton Lenis instance — momentum scrolling for the whole site.
// Reduced-motion visitors keep native scrolling (no instance is created).
let lenis = null;

export const initLenis = () => {
    if (lenis) return lenis;
    if (typeof window === "undefined") return null;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return null;
    lenis = new Lenis({
        autoRaf: true,
        duration: 1.15,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    });
    return lenis;
};

export const getLenis = () => lenis;
